import type { AppStrings } from './types.js';
import { plural } from './plural.js';

export const kk: AppStrings = {
  // COMMON
  error_title: 'Қате',
  cancel: 'Болдырмау',
  retry: 'Қайталау',
  back_arrow: '← Артқа',

  // ASK SCREEN
  ask_box_unavailable: 'Жәшік қолжетімсіз',
  ask_box_unavailable_desc: 'Сілтеме ескірген немесе иесі жәшікті жапқан шығар.',
  ask_create_own_box: 'Өз жәшігіңді жасау',
  ask_sent_title: 'Жіберілді ✅',
  ask_sent_desc: 'Анонимді сұрақ жәшік иесіне жетті.',
  ask_anonymous_hint: 'Сұрағың анонимді жіберіледі.',
  ask_placeholder: 'Сұрағыңды жаз…',
  ask_send: 'Жіберу',
  ask_sending: 'Жіберілуде…',
  ask_error_rate_limit: 'Тым жиі, бір минут күте тұр.',
  ask_error_restart: 'Mini App қайта іске қос.',
  ask_error_load: 'Жәшікті жүктеу мүмкін болмады.',
  ask_error_send: 'Сұрақты жіберу мүмкін болмады.',
  ask_error_banned: 'Сен қосымшадан бұғатталдың.',
  ask_banned_appeal_btn: 'Шағымдану',
  ask_appeal_sent: 'Шағым жіберілді. Оны қолмен қарастырамыз.',

  // AGE GATE
  age_gate_title: 'Тек 18+ үшін',
  age_gate_desc:
    'Сен анонимді сұрақ жіберіп жатырсың. Сыйластықпен болыңдар: қорлау, қорқыту, кәмелетке толмағандарға арналған сексуалдық мазмұн және заңға қайшы кез келген мазмұн тыйым салынған. Анонимділік жазасыздықты білдірмейді — бұзушылықтар модерацияға жіберіледі. Сұрақ жіберу арқылы сен 18 жаста екеніңді растайсың және ережелерді қабылдайсың.',
  age_gate_confirm: 'Маған 18 бар — жалғастыру',

  // INBOX SCREEN
  inbox_title: 'Сұрақтар жәшігі',
  box_link_accordion: 'Шақыру сілтемесі',
  inbox_notifications_ask: '🔔 Ботқа жаңа сұрақтар туралы хабарлама жіберуге рұқсат беру?',
  inbox_notifications_allow: 'Рұқсат беру',
  inbox_notifications_dismiss_label: 'Жабу',
  inbox_box_toggle_disable: 'Қабылдауды өшіру',
  inbox_box_toggle_enable: 'Қабылдауды қосу',
  inbox_box_disabled_warning: 'Сұрақтарды қабылдау өшірілді — жаңа сұрақтар қабылданбайды.',
  inbox_share_hint: 'Сілтемені бөліс — достарың саған анонимді сұрақтар қоя алады.',
  inbox_copy: 'Көшіру',
  inbox_copied: 'Көшірілді',
  inbox_copy_error: 'Қате',
  inbox_no_deeplink: 'Сілтеме deploy-дан кейін пайда болады.',
  inbox_invite_story: 'Story арқылы шақыру',
  inbox_invite_chat: 'Чат арқылы шақыру',
  inbox_card_rendering: 'Шақыру картасы әлі өңделуде.',
  inbox_story_unsupported:
    'Story Telegram-ның бұл нұсқасында қолжетімсіз. «Чат арқылы» байқап көр.',
  inbox_story_error: 'Story ашу мүмкін болмады.',
  inbox_chat_unsupported:
    'Чатпен бөлісу Telegram-ның бұл нұсқасында қолжетімсіз. Клиентті жаңарт.',
  inbox_chat_error: 'Бөлісу мүмкін болмады. Қайталап байқа.',
  inbox_chat_prepare_error: 'Шақыруды дайындау мүмкін болмады.',
  inbox_filter_incoming: 'Кіріс',
  inbox_filter_hidden: 'Жасырылған',
  inbox_filter_blocked: 'Бұғатталған',
  inbox_filter_empty: 'Мұнда әлі ештеңе жоқ.',
  inbox_acc_unanswered: 'Жауапсыз',
  inbox_acc_answered: 'Жауап берілген',
  inbox_acc_hidden: 'Жасырылған',
  inbox_acc_blocked: 'Бұғатталған',
  inbox_empty: 'Әлі сұрақ жоқ. Жоғарыдағы сілтемені бөліс.',
  inbox_load_more: 'Тағы жүктеу',
  inbox_load_more_error: 'Келесі бетті жүктеу мүмкін болмады.',
  inbox_error_load: 'Жәшікті жүктеу мүмкін болмады.',
  inbox_rate_limit: 'Тым жиі, бір минут күте тұр.',
  inbox_toggle_error: 'Жәшік күйін өзгерту мүмкін болмады.',

  // MESSAGE BOX (Трек D)
  message_tagline: 'Маған анонимді хабарлама жаз',
  message_placeholder: 'Хабарлама жаз…',
  message_anonymous_hint: 'Хабарламаң анонимді жіберіледі.',
  message_sent_title: 'Жіберілді ✅',
  message_sent_desc: 'Анонимді хабарламаң жеткізілді.',
  message_owner_entry: 'Маған жаз',
  message_share_hint: 'Сілтемені бөліс — кез келген адам саған анонимді хабарлама жібере алады.',
  message_inbox_open: 'Алынған хабарламалар',
  message_inbox_title: 'Хабарламалар',
  message_inbox_empty: 'Әлі хабарлама жоқ. Жоғарыдағы сілтемеңді бөліс.',

  // ANSWER SCREEN
  answer_title: 'Сұраққа жауап',
  answer_placeholder: 'Жауабыңды жаз…',
  answer_submit: 'Жіберу',
  answer_submitting: 'Жіберілуде…',
  answer_back: 'Артқа',
  answer_error_send: 'Жауапты жіберу мүмкін болмады.',

  // SHARE SCREEN
  share_title: 'Жауап жарияланды ✅',
  share_hint: 'Картаны бөліс және тағы сұрақтар жина.',
  share_card_rendering_desc:
    'Карта әлі өңделуде. Сұрақтарға оралып, кейінірек тексер — Story немесе чатта бөліс.',
  share_card_alt: 'Жауап картасы',
  share_story_btn: 'Story-ге бөлісу',
  share_story_btn_busy: 'Ашылуда…',
  share_chat_btn: 'Чатқа бөлісу',
  share_chat_btn_busy: 'Дайындалуда…',
  share_back: 'Сұрақтарға оралу',
  share_story_unsupported:
    'Story Telegram-ның бұл нұсқасында қолжетімсіз. «Чатқа бөлісу» байқа.',
  share_story_error: 'Story ашу мүмкін болмады. «Чатқа бөлісу» байқа.',
  share_chat_sent: 'Хабарлама жіберілді.',
  share_chat_unsupported:
    'Чатпен бөлісу Telegram-ның бұл нұсқасында қолжетімсіз. Клиентті жаңарт.',
  share_chat_error: 'Бөлісу мүмкін болмады. Қайталап байқа.',
  share_chat_prepare_error: 'Хабарламаны дайындау мүмкін болмады.',

  // LEADERBOARD SCREEN
  lb_title: 'Рейтинг',
  lb_period_7d: '7 күн',
  lb_period_30d: '30 күн',
  lb_period_all: 'Барлық уақыт',
  lb_group_label: 'Санат',
  lb_group_all: 'Барлығы',
  lb_group_ask: 'Сұрақтар',
  lb_group_rate: 'Бағалар',
  lb_group_confession: 'Мойындаулар',
  lb_group_guesswho: 'Кім екенін тап',
  lb_group_message: 'Хабарламалар',
  lb_error: 'Рейтингті жүктеу мүмкін болмады',
  lb_empty: 'Рейтингте әлі ешкім жоқ',
  lb_anon: 'Аноним',
  lb_load_more: 'Тағы жүктеу',
  lb_questions: (n) => `${n} сұр.`,
  lb_referrals: (n) => `${n} реф.`,

  // REWARDS SCREEN
  rw_title: 'Менің сыйлықтарым',
  rw_error: 'Сыйлықтарды жүктеу мүмкін болмады',
  rw_level: (n) => `${n}-деңгей`,
  rw_confirmed_referrals: (n) =>
    plural('kk', n, {
      one: '{n} расталған реферал',
      other: '{n} расталған реферал',
    }),
  rw_next_level_section: (n) =>
    plural('kk', n, {
      one: 'КЕЛЕСІ ДЕҢГЕЙ — {n} реферал',
      other: 'КЕЛЕСІ ДЕҢГЕЙ — {n} реферал',
    }),
  rw_to_level: (level, target) => `${level}-деңгейге дейін: ${target}`,
  rw_max_level: 'Максималды деңгейге жетті!',
  rw_badges_section: 'БЕЛГІЛЕР',
  rw_formats_section: 'ЖӘШІК ФОРМАТТАРЫ',

  // QUESTION CARD
  qcard_status_new: 'Жаңа',
  qcard_status_hidden: 'Жасырылған',
  qcard_status_answered: 'Жауап берілді',
  qcard_moderation_flagged: 'Абайла: күмәнді хабарлама',
  qcard_answer_btn: 'Жауап беру',
  qcard_answer_send: 'Жіберу',
  qcard_share_btn: 'Бөлісу',
  qcard_hide_btn: 'Жасыру',
  qcard_show_btn: 'Көрсету',
  qcard_report_btn: 'Шағымдану',
  qcard_block_btn: 'Бұғаттау',
  qcard_unblock_btn: 'Бұғатты ашу',
  qcard_report_reason_label: 'Шағым себебін таңда:',
  qcard_reason_spam: 'Спам',
  qcard_reason_harassment: 'Қорлау',
  qcard_reason_sexual: 'Сексуалдық мазмұн',
  qcard_reason_other: 'Басқа',
  qcard_error_hide: 'Көрінуді өзгерту мүмкін болмады.',
  qcard_error_report: 'Шағымды жіберу мүмкін болмады.',
  qcard_error_block: 'Жіберушіні бұғаттау мүмкін болмады.',
  qcard_report_done: 'Шағым жіберілді — рахмет.',
  qcard_block_done: 'Жіберуші бұғатталды.',
  qcard_unblock_done: 'Жіберушінің бұғаты ашылды.',

  // ERRORS
  err_network: 'Серверге қосылу жоқ. Интернетті тексеріп, қайталап байқа.',
  err_server_unavailable: 'Сервер уақытша қолжетімсіз, кейінірек байқа.',
  err_internal: 'Бірдеңе дұрыс болмады. Біз білеміз — кейінірек байқа.',
  err_bad_request: 'Енгізілген деректерді тексер.',
  err_generic: 'Әрекетті орындау мүмкін болмады, кейінірек байқа.',
  err_schema: 'Деректер қатесі. Қосымшаны жаңартып байқа.',
  share_story_link_premium_note:
    'Story-дегі сілтемені Telegram тек Premium-мен береді. Онсыз да достарың сені табады — атауың картада бар.',

  // AUTH ERROR SCREEN
  auth_error_title: 'Кіру қатесі',
  auth_error_desc:
    'Аутентификация сәтсіз болды. Mini App-ты Telegram арқылы жауып, қайта аш.',

  // REWARD TOAST
  reward_toast_title: 'Жаңа сыйлық!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'Сұрақтар',
  tab_leaderboard: 'Рейтинг',
  tab_rewards: 'Сыйлықтар',
  tab_settings: 'Баптаулар',

  // SETTINGS SCREEN
  settings_title: 'Баптаулар',
  settings_section_general: 'Жалпы',
  settings_notifications: 'Жаңа сұрақтар туралы хабарламалар',
  settings_notifications_hint: 'Бот саған сұрақ қойылғанда хабарлама жібереді.',
  settings_notifications_error: 'Хабарлама баптауын сақтау мүмкін болмады.',
  settings_language: 'Тіл',
  settings_language_error: 'Тілді өзгерту мүмкін болмады. Қайталап байқа.',
  settings_section_about: 'Қосымша туралы',
  settings_version: 'Нұсқасы',

  // CODE ENTRY (work-020)
  code_modal_title: 'Story сілтемесі — тек Premium үшін',
  code_modal_explain:
    'Telegram Story-де кликабельді сілтемені тек Premium жазылушыларына береді. Бірақ Story-ге кодыңды қосуға болады — көрермендер оны қосымшаға енгізіп, саған анонимді сұрақ қояды.',
  code_modal_your_code: 'Сенің кодың',
  code_modal_copy: 'Кодты көшіру',
  code_modal_copied: 'Көшірілді',
  code_modal_share_btn: 'Story-ге бөлісу',
  code_modal_loading: 'Код алынуда…',
  code_modal_error: 'Кодты алу мүмкін болмады. Кейінірек байқа.',
  ask_code_title: 'Код енгіз',
  ask_code_desc:
    'Story-ден өттің бе? Ондағы кодты тап (мысалы, 1234) және төменге енгіз.',
  ask_code_placeholder: 'Story-дегі код',
  ask_code_find: 'Іздеу',
  ask_code_not_found: 'Код табылмады. Цифрларды тексеріп, қайталап байқа.',
  ask_code_invalid: 'Код 4 цифрдан тұрады.',
  code_onboarding_header: 'Story-ден келдің бе?',
  code_onboarding_text: 'Досыңның кодын енгіз де оған анонимді сұрақ қой.',
  code_onboarding_action: 'Код енгізу',
  settings_ask_by_code: 'Кодпен сұрау',
  settings_my_code_title: 'Story үшін кодың',
  settings_my_code_hint:
    'Бұл кодты Story-ге жаз — көрермендер оны енгізіп, саған анонимді сұрақ қояды. Telegram кликабельді сілтемені Story-де тек Premium жазылушыларына береді.',
  settings_my_code_rotate: 'Жаңа код алу',
  settings_my_code_rotating: 'Жаңартылуда…',
  settings_my_code_done: 'Код жаңартылды',
  settings_my_code_error: 'Кодты алу мүмкін болмады.',
  settings_my_code_rotate_confirm_title: 'Кодты ауыстырасың ба?',
  settings_my_code_rotate_confirm_desc:
    'Ескі кодың сол сәтте істемей қалады. Оны story-де көргендер саған енді жаза алмайды. Біреу спамдап жатса ғана ауыстыр.',
  settings_my_code_rotate_confirm_action: 'Кодты ауыстыру',

  // BOT
  bot_greeting: (name) => (name ? `Сәлем, ${name}! 👋` : 'Сәлем! 👋'),
  bot_onboarding:
    'Бұл VeylMe — анонимді сұрақтар.\n\n' +
    'Mini App-ті аш, Story-ге «Маған анонимді сұрақ қой» карточкасын жариялa — ' +
    'анонимді сұрақтар тікелей осында келеді.\n\n' +
    '⚠️ 18+. Сыйластықты сақта: қорлау, қорқыту және тыйым салынған мазмұн ' +
    'рұқсат етілмейді. Анонимдік ≠ жазасыздық — бұзушылықтар модерацияға жіберіледі.',
  bot_open_btn: 'VeylMe ашу',
  notify_answer_btn: 'Жауап беру',
  bot_invite_text:
    'Біреу VeylMe сілтемесін бөлісті.\n\n' +
    'Анонимді сұрақ қою үшін Mini App-ті аш:',
  bot_invite_btn: 'Анонимді сұрау',

  // WORK-027 i18n sweep
  tagline: 'Маған анонимді сұрақ қой',
  share_ask_action: 'Сұрау',
  share_answered_text: 'Мен анонимді сұраққа жауап бердім 👀',
  err_not_in_telegram: 'Mini App Telegram-да жұмыс істемей тұр. Қосымшаны қайта іске қос.',
  badge_viral_starter: 'Вирустық старт',
  badge_storyteller: 'Әңгімеші',
  badge_loop_master: 'Цикл шебері',
  theme_confession: 'Мойындаулар',
  theme_guesswho: 'Кім екенін тап',
  rw_format_named: (name) => `формат «${name}»`,
  card_label_question: 'Сұрақ',
  card_label_answer: 'Жауап',
  card_invite_subtitle: 'анонимді, тіркелусіз',
  card_code_hint: 'ҚОСЫМШАҒА КОДТЫ ЕНГІЗ',
  share_msg_title: (brand) => `${brand} · Анонимді сұрақтар`,
  notify_new_question: '🔔 Сізге анонимді сұрақ қойылды',
  notify_unanswered_reminder: (n) =>
    plural('kk', n, {
      one: '🔔 Сізде {n} жауапсыз сұрақ бар',
      other: '🔔 Сізде {n} жауапсыз сұрақ бар',
    }),
  notify_ban_permanent: 'мәңгілікке',
  notify_ban_until: (date) => `${date} дейін`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ Сен VeylMe-де ${untilPhrase} бұғатталдың. Тым көп алушы сенің хабарламаларыңа шағымданды.\nБұл қате деп ойласаң, қосымшада шағым бере аласың.`,
  notify_warning_msg:
    '⚠️ Бірнеше алушы сенің хабарламаларыңа шағымданды. Тағы бірнеше — және сен VeylMe-де бұғатталасың.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'Менің сұрақтарым',
  my_questions_empty_title: 'Сен әлі сұрақ қойған жоқсың',
  my_questions_empty_desc: 'Біреудің жәшігіне сұрақ қой — жауап осында пайда болады.',
  my_questions_loading: 'Жауап бар-жоғы тексерілуде…',
  my_questions_waiting: 'Жауап күтілуде',
  my_questions_answer_label: 'Жауап',
  settings_my_questions: 'Менің сұрақтарым',
  ask_sent_find_reply_hint: 'Жауапты кейінірек «Менің сұрақтарым» бөлімінен таба аласың.',
  inbox_story_nonpremium_hint: 'Telegram Premium болмаса, Story сілтемесі басылмайды, сондықтан код көрсетіледі — чатқа бөлісу сенімдірек.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'Telegram рұқсатының мерзімі өтті',
  session_expired_desc: 'Telegram қолданбаға рұқсатты іске қосылғанда бір рет қана береді, ал бұл рұқсаттың мерзімі өтіп кеткен. Қолданбаны қайта аш — бастаған мәтініңді сақтап қойдық.',
  session_expired_desc_no_storage: 'Telegram рұқсатыңның мерзімі өтіп кетті, қолданбаны қайта ашу керек. Сен жазған мәтінді сақтай алмадық — шыға берер алдында оны көшіріп ал.',
  session_expired_reopen: 'Қайта ашу',
  session_expired_stuck_title: 'Telegram сол ескі рұқсатты қайта берді',
  session_expired_stuck_desc: 'Қолданбаны бот мәзірі арқылы толық жауып, қайта аш — сонда Telegram жаңа рұқсат береді.',
  session_auth_failed_title: 'Кіруді растау мүмкін болмады',
  session_auth_failed_desc: 'Telegram қолданбаға кіруіңді растамады. Қолданбаны жауып, ботпен чаттан қайта аш.',
  session_expired_manual_close: 'Қолданба өзін осы жерден жаба алмайды — оны өзің жауып, ботпен чаттан қайта аш.',
  session_expiring_soon: 'Telegram рұқсатының мерзімі жақында бітеді. Ештеңе жоғалмас үшін қолданбаны қайта аш.',
  my_questions_check_failed: 'Жауаптарды тексеру мүмкін болмады. Кейінірек қайталап көр.',
  settings_notifications_load_error: 'Баптауды жүктеу мүмкін болмады.',
};
